import { render, staticRenderFns } from "./OData.vue?vue&type=template&id=bc5a174a&"
import script from "./OData.vue?vue&type=script&lang=js&"
export * from "./OData.vue?vue&type=script&lang=js&"
import style0 from "./OData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports